module.exports = __webpack_public_path__ + "img/s7-300x143.772e85a1.jpg";